import React, { useState } from 'react';
import { Offcanvas, OffcanvasHeader, OffcanvasBody, Button } from 'reactstrap';
import CouponForm from './CouponForm';

const CouponFormPopup = ({
  coupon,
  updateCoupon,
  pageOffset,
  pageSize,
  promotionId,
  createOrUpdateCouponFunc,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Button
        type="button"
        size="lg"
        outline
        color="secondary"
        className="btn-ghost-secondary shadow-none px-2 py-1"
        onClick={toggle}
      >
        <i className="ri-pencil-line align-middle"></i>
      </Button>

      <Offcanvas
        isOpen={isOpen}
        toggle={toggle}
        direction="end"
        style={{ width: '90vw' }}
      >
        <OffcanvasHeader toggle={toggle} className="border-bottom pb-3">
          CODE: {coupon?.code}
        </OffcanvasHeader>
        <OffcanvasBody>
          <CouponForm
            handleClose={toggle}
            coupon={coupon}
            updateCoupon={updateCoupon}
            pageOffset={pageOffset}
            pageSize={pageSize}
            promotionId={promotionId}
            createOrUpdateCouponFunc={createOrUpdateCouponFunc}
          />
        </OffcanvasBody>
      </Offcanvas>
    </>
  );
};

export default CouponFormPopup;
